<div *ngIf="(isLoggedIn$ | async) && (banner$ | async) as banner" tabindex="-1">
  <div
    *ngIf="banner.isActive && banner.message?.trim()"
    class="custom-banner"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    #bannerContainer
    id="site-banner"
    tabindex="0"
    aria-labelledby="banner-live"  
  >
    <p class="sr-only" id="banner-live">
      Site notice: {{ banner.message }}
    </p>

    <div class="marquee" aria-describedby="banner-live" aria-hidden="true">
      <div #marqueeContent class="marquee-content"
           [style.--duration]="marqueeDuration"
           [style.--startX.px]="startX"
           [style.--endX.px]="endX"
           [style.--delay]="marqueeDelay">
        <span class="marquee-text">{{ banner.message }}</span>
      </div>
    </div>
  </div>
</div>


<button class="skip-to-content-link" (click)="skipToContent()">Skip to Main Content</button>

<router-outlet></router-outlet>
<label class="sr-only" for="g-recaptcha-response-100000">Re-Captcha</label>
<label class="sr-only" for="g-recaptcha-response">Re-Captcha Response</label>